"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var react_1 = __importDefault(require("react"));
var react_query_1 = require("react-query");
var tooltip_1 = __importDefault(require("../../../../plugins/tooltip"));
var YotpoRewards = function () {
    var _a;
    // Map min points to displayed reward. Must be in descending order of minPoints.
    var rewards = [
        { minPoints: 400, rewardDollars: 20 },
        { minPoints: 300, rewardDollars: 15 },
        { minPoints: 200, rewardDollars: 10 },
        { minPoints: 100, rewardDollars: 5 },
    ];
    var customerDetailsQuery = (0, react_query_1.useQuery)(['swellCustomerDetails'], function () {
        return new Promise(function (resolve) {
            (0, jquery_1.default)(document).on('swell:setup', function () {
                var _a;
                var customerDetails = (_a = window.swellAPI) === null || _a === void 0 ? void 0 : _a.getCustomerDetails();
                if (!customerDetails)
                    throw new Error('Yotpo missing customer details');
                var reward = (function () {
                    var e_1, _a;
                    if (customerDetails.pointsBalance === undefined)
                        return { pointsToRedeem: 0, rewardDollars: 0 };
                    try {
                        for (var rewards_1 = __values(rewards), rewards_1_1 = rewards_1.next(); !rewards_1_1.done; rewards_1_1 = rewards_1.next()) {
                            var rw = rewards_1_1.value;
                            if (customerDetails.pointsBalance >= rw.minPoints) {
                                return { pointsToRedeem: rw.minPoints, rewardDollars: rw.rewardDollars };
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (rewards_1_1 && !rewards_1_1.done && (_a = rewards_1.return)) _a.call(rewards_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return { pointsToRedeem: customerDetails.pointsBalance, rewardDollars: 0 };
                })();
                resolve({ customerDetails: customerDetails, reward: reward });
            });
        });
    });
    return (react_1.default.createElement("div", { className: 'position-relative' },
        react_1.default.createElement("a", { className: 'position-absolute z20 top-0 left-0 height-100 width-100', href: '/pages/hello-bello-rewards' }),
        react_1.default.createElement("div", { className: 'account-container padding-vertical-4 padding-horizontal-3 bg-white bordered border-very-light-pink grid-x grid-padding-x' },
            react_1.default.createElement("div", { className: 'cell small-8 text-left font-size-14 padding-left-4 flex-container items-center' },
                react_1.default.createElement("img", { className: 'h-4 padding-right-3', src: window.accountApp.iconUrls.star, alt: 'Star icon' }),
                "Rewards"),
            react_1.default.createElement("div", { className: 'cell small-4 text-right flex-container items-center justify-end space-x-2' },
                ((_a = customerDetailsQuery.data) === null || _a === void 0 ? void 0 : _a.customerDetails.pointsBalance) !== undefined &&
                    customerDetailsQuery.data.customerDetails.pointsBalance > 0 &&
                    customerDetailsQuery.data.reward.rewardDollars > 0 && (react_1.default.createElement("div", { className: 'padding-2 z100 bg-wisteria text-white font-size-12 font-lighter rounded-md flex-container space-x-1', style: { whiteSpace: 'nowrap' } },
                    react_1.default.createElement(tooltip_1.default, { button: react_1.default.createElement("i", { className: 'ss-info font-size-14 font-lighter', style: { verticalAlign: 'middle', lineHeight: '100%' } }) },
                        react_1.default.createElement("div", { className: 'padding-3 font-size-small' },
                            "Redeem ",
                            customerDetailsQuery.data.reward.pointsToRedeem,
                            " Points for $",
                            customerDetailsQuery.data.reward.rewardDollars,
                            " off! You have",
                            ' ',
                            customerDetailsQuery.data.customerDetails.pointsBalance,
                            " Points.")),
                    react_1.default.createElement("div", null,
                        "Claim $",
                        customerDetailsQuery.data.reward.rewardDollars,
                        " Off"))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("i", { id: 'show-payment', className: 'ss-right' }))))));
};
exports.default = YotpoRewards;
